function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { Documents } from "./Documents";
import { path } from "../util/path";
import { Nodes } from "./Nodes";
function image2assets(images) {
  var assets = [];
  var _iterator = _createForOfIteratorHelper(images),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var image = _step.value;
      var ext = path.extname(image);
      if (ext === '.gif') {
        assets.push({
          id: encodeURIComponent(image),
          type: 'bundle',
          contentType: 'video/gif',
          url: image
        });
      } else {
        if (image.endsWith('.svg')) {
          assets.push({
            id: encodeURIComponent(image),
            type: 'bundle',
            contentType: 'image/svg+xml',
            url: image
          });
        } else {
          assets.push({
            id: encodeURIComponent(image),
            type: 'bundle',
            contentType: 'image',
            url: image
          });
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return assets;
}
function graphic2assets(graphics) {
  var assets = [];
  var _iterator2 = _createForOfIteratorHelper(graphics),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var graphic = _step2.value;
      var url = graphic.properties.url;
      assets.push({
        id: encodeURIComponent(url),
        type: 'bundle',
        contentType: 'shape',
        url: url
      });
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return assets;
}
function shape2assets(shapes) {
  var assets = [];
  var _iterator3 = _createForOfIteratorHelper(shapes),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var shape = _step3.value;
      var paths = shape.properties.paths;
      var _iterator4 = _createForOfIteratorHelper(paths),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _path = _step4.value;
          var fill = _path.fill;
          if ((fill === null || fill === void 0 ? void 0 : fill.type) === 'pattern') {
            var pattern = fill.pattern;
            if (pattern) {
              var src = pattern.src;
              if (src) {
                assets.push({
                  id: encodeURIComponent(src),
                  type: 'bundle',
                  contentType: 'image',
                  url: src
                });
              }
            }
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return assets;
}
function resolveElementImage(element) {
  switch (element.as) {
    case "Image":
      {
        var _properties$content;
        var properties = element.properties;
        var src = (_properties$content = properties.content) === null || _properties$content === void 0 ? void 0 : _properties$content.src;
        if (src) {
          return src;
        }
        break;
      }
    case "ClippathImage":
      {
        var _properties$content2;
        var _properties = element.properties;
        var _src = (_properties$content2 = _properties.content) === null || _properties$content2 === void 0 ? void 0 : _properties$content2.src;
        if (_src) {
          return _src;
        }
        break;
      }
  }
  return undefined;
}
function imageVisitor(set) {
  return {
    element: {
      enter: function enter(node, _parentNode) {
        var image = resolveElementImage(node);
        if (image) {
          set.add(image);
        }
      }
    }
  };
}
function resolveImages(document) {
  var resources = new Set();
  function visitLayout(layout) {
    var _layout$background;
    if ((_layout$background = layout.background) !== null && _layout$background !== void 0 && (_layout$background = _layout$background.image) !== null && _layout$background !== void 0 && _layout$background.url) {
      resources.add(layout.background.image.url);
    }
  }
  if (Documents.isPageDocument(document)) {
    if (Documents.isPageLayoutDocument(document)) {
      visitLayout(document);
    } else {
      var _iterator5 = _createForOfIteratorHelper(document.layouts),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var layout = _step5.value;
          visitLayout(layout);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  } else if (Documents.isImageDocument(document)) {
    visitLayout(document);
  }
  Documents.visitElement(document, imageVisitor(resources));
  return resources;
}
function resolveGraphics(document) {
  var elements = [];
  Documents.visitElement(document, {
    element: {
      enter: function enter(element) {
        switch (element.as) {
          case "Graphic":
            {
              elements.push(element);
            }
        }
      }
    }
  });
  return elements;
}

// function resolveAssets(document: Document): Asset[] {
//     const images = resolveImages(document);
//     const graphics = resolveGraphics(document);
//     const shapes = DocumentElements.visitSourceElement(source, ['Shape']);
//     return [
//         ...image2assets(images),
//         ...graphic2assets(graphics)
//     ];
// }
export var DocumentElements;
(function (_DocumentElements) {
  function visitSourceElement(source, as) {
    var elements = [];
    var visitor = {
      element: {
        enter: function enter(element) {
          if (as.includes(element.as)) {
            elements.push(element);
          }
        }
      }
    };
    if (Documents.isDocument(source)) {
      Documents.visitElement(source, visitor);
    } else {
      Nodes.visit(source.elements, visitor);
    }
    return elements;
  }
  _DocumentElements.visitSourceElement = visitSourceElement;
  function resolveImageElements(source) {
    return visitSourceElement(source, ['Image', 'ClippathImage']);
  }
  _DocumentElements.resolveImageElements = resolveImageElements;
  function resolveGraphicElements(source) {
    return visitSourceElement(source, ['Graphic']);
  }
  _DocumentElements.resolveGraphicElements = resolveGraphicElements;
  function resolveMapElements(source) {
    return visitSourceElement(source, ['StaticMap']);
  }
  _DocumentElements.resolveMapElements = resolveMapElements;
  function resolveBackgroundImages(source) {
    var images = [];
    Documents.visit(source, {
      background: function background(_background) {
        var _background$image;
        if (_background !== null && _background !== void 0 && (_background$image = _background.image) !== null && _background$image !== void 0 && _background$image.url) {
          images.push(_background.image.url);
        }
      }
    });
    return images;
  }
  _DocumentElements.resolveBackgroundImages = resolveBackgroundImages;
  function resolveImage(source) {
    var images = new Set();
    Documents.visit(source, {
      background: function background(_background2) {
        var _background2$image;
        if (_background2 !== null && _background2 !== void 0 && (_background2$image = _background2.image) !== null && _background2$image !== void 0 && _background2$image.url) {
          images.add(_background2.image.url);
        }
      },
      element: {
        enter: function enter(node, _parentNode) {
          var image = resolveElementImage(node);
          if (image) {
            images.add(image);
          }
        }
      }
    });
    return images;
  }
  _DocumentElements.resolveImage = resolveImage;
})(DocumentElements || (DocumentElements = {}));
export var DocumentAssets;
(function (_DocumentAssets) {
  var resolveImage = DocumentElements.resolveImage;
  function resolveImageOfLayout(source) {
    var _background$image2;
    var background = source.background,
      elements = source.elements;
    var resources = new Set();
    if (background !== null && background !== void 0 && (_background$image2 = background.image) !== null && _background$image2 !== void 0 && _background$image2.url) {
      resources.add(background.image.url);
    }
    Nodes.visit(elements, imageVisitor(resources));
    return resources;
  }

  //TODO 优化为同上  使用Documents.visit
  function valueOf(source) {
    var images;
    if (Documents.isDocument(source)) {
      images = resolveImage(source);
    } else {
      images = resolveImageOfLayout(source);
    }
    var graphics = DocumentElements.resolveGraphicElements(source);
    var shapes = DocumentElements.visitSourceElement(source, ['Shape']);
    return [].concat(_toConsumableArray(image2assets(images)), _toConsumableArray(graphic2assets(graphics)), _toConsumableArray(shape2assets(shapes)));
  }
  _DocumentAssets.valueOf = valueOf;
})(DocumentAssets || (DocumentAssets = {}));